<template>
  <div>
    <vs-button v-if="type == 'new'" icon="add" @click="onPopup">ADD</vs-button>
    <vs-icon
      v-else
      @click="onPopup"
      class="btn-icon"
      icon="edit"
      color="#32c040"
    ></vs-icon>
    <vs-popup title="Manage Schedule" :active.sync="popupActivoAdd" background-color-popup="var(--background-color-sidebar)">
      <div class="add">
        <div>
          <vs-input
            class="name"
            label="Name"
            placeholder="Name"
            v-model="name_schedule"
          />
        </div>
        <div class="time">
          <div>
            <span>Time Close : </span>
            <vue-timepicker v-model="timeclose"></vue-timepicker>
          </div>
          <div>
            <span>Time Open : </span>
            <vue-timepicker v-model="timeopen"></vue-timepicker>
          </div>
          <div class="temp" v-if="device == 'air'">
            <div>
              <span>Temperature : </span>
              <vs-switch color="success" v-model="temperature.state" />
            </div>
            <div>
              <vs-input-number
                min="16"
                max="30"
                :disabled="!temperature.state"
                v-model="temperature.temp"
              />
            </div>
          </div>
        </div>
        <div class="list-week">
          <button class="circle-btn" :class="Su" @click="selectDate('Su')">
            Su
          </button>
          <button class="circle-btn" :class="Mo" @click="selectDate('Mo')">
            Mo
          </button>
          <button class="circle-btn" :class="Tu" @click="selectDate('Tu')">
            Tu
          </button>
          <button class="circle-btn" :class="We" @click="selectDate('We')">
            We
          </button>
          <button class="circle-btn" :class="Th" @click="selectDate('Th')">
            Th
          </button>
          <button class="circle-btn" :class="Fr" @click="selectDate('Fr')">
            Fr
          </button>
          <button class="circle-btn" :class="Sa" @click="selectDate('Sa')">
            Sa
          </button>

          <!-- <button
            class="circle-btn"
            :class="item[1]"
            @click="selectDate(item[0])"
            v-for="(item, index) in dateofweek"
            :key="index"
          >
            {{ item[0] }}{{item[1]}}
          </button> -->
        </div>
        <div class="btn-submit" v-if="type == 'new'">
          <vs-button @click="addSchedule">Submit</vs-button>
        </div>
        <div class="btn-submit" v-else>
          <vs-button @click="editSchedule">Submit</vs-button>
          <vs-button @click="removeSchedule" color="#ff0000">Remove</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";

export default {
  components: {
    VueTimepicker,
  },
  props: {
    type: { type: String, default: "new" },
    device: { type: String, default: "light" },
    nameSchedule: { type: String, default: "" },
    TimeClose: { type: String, default: "" },
    TimeOpen: { type: String, default: "" },
    on: { type: Boolean, default: false },
    id: { type: Number, default: null },
    device_id: {
      type: String,
      default: "",
    },
    temperature: {
      type: Object,
      default: {
        state: true,
        temp: 25,
      },
    },
    week: {
      type: Object,
      default: {
        Su: false,
        Mo: false,
        Tu: false,
        We: false,
        Th: false,
        Fr: false,
        Sa: false,
      },
    },
    floor: { type: Number, default: undefined },
    index: { type: Number, default: undefined },
  },
  computed: {
    Su: function () {
      return { active: this.week.Su };
    },
    Mo: function () {
      return { active: this.week.Mo };
    },
    Tu: function () {
      return { active: this.week.Tu };
    },
    We: function () {
      return { active: this.week.We };
    },
    Th: function () {
      return { active: this.week.Th };
    },
    Fr: function () {
      return { active: this.week.Fr };
    },
    Sa: function () {
      return { active: this.week.Sa };
    },
  },
  data() {
    return {
      popupActivoAdd: false,
      timeopen: "",
      timeclose: "",
      name_schedule: "",
    };
  },
  mounted() {
    this.timeopen = this.TimeOpen;
    this.timeclose = this.TimeOpen;
    this.name_schedule = this.nameSchedule;
    console.log(this.device_id);
  },
  methods: {
    onNameChange() {
      this.nameSchedule = this.nameSchedule;
    },
    onPopup() {
      this.popupActivoAdd = true;
      this.$emit("close-popup", false);
    },
    selectDate(v) {
      console.log(v, this.Su);
      console.log("susususu");
      this.week[v] = !this.week[v];
    },
    addSchedule() {
      console.log(this.TimeClose, this.TimeOpen);
      if (
        this.timeclose != "" &&
        this.timeopen != "" &&
        this.name_schedule != ""
      ) {

        let schedule = this.schedule_obj();
        console.log(schedule);
        if (schedule.device_id == "" || schedule.device_id == undefined) {
          alert("No device");
        } else {
          this.$API.post("schedule/v2.0/add", schedule).then(() => {
            // alert("success")
            console.log("add schedule success");
            this.$store.dispatch("i_APC/genData");

            this.$store.dispatch("i_APC/getSchedule");
            this.popupActivoAdd = false;
            this.$vs.notify({
              title: "Notification",
              text: "Add New Schedule success",
              color: "success",
              position: "top-center",
            });
          });
        }
      }
    },
    editSchedule() {
      if (
        this.timeclose != "" &&
        this.timeopen != "" &&
        this.name_schedule != ""
      ) {
        let schedule = this.schedule_obj();
        schedule["id"] = this.id;
        this.$API.post("schedule/v2.0/edit", schedule).then(() => {
          // alert("success")
          this.$API
            .post("schedule/v2.0/active", {
              id: this.id,
              active: true,
            })
            .then(() => {
              console.log("Change Active status");
            });
          this.$store.dispatch("i_APC/genData");

          this.$store.dispatch("i_APC/getSchedule");
          this.popupActivoAdd = false;
          this.$vs.notify({
            title: "Notification",
            text: "Edit Schedule success",
            color: "success",
            position: "top-center",
          });
        });
      }
    },
    schedule_obj() {
      let timeopen =
        this.timeopen.indexOf("HH") == -1 || this.Timeopen.indexOf("mm") == -1
          ? this.timeopen.replace(/HH|mm/g, "00")
          : this.timeopen;
      let timeclose =
        this.timeclose.indexOf("HH") == -1 || this.timeclose.indexOf("mm") == -1
          ? this.timeclose.replace(/HH|mm/g, "00")
          : this.timeclose;

      let schedule = {
        name: this.name_schedule,
        date_list: [
          this.week.Su,
          this.week.Mo,
          this.week.Tu,
          this.week.We,
          this.week.Th,
          this.week.Fr,
          this.week.Sa,
        ],
        start_time:
          this.$moment().format("YYYY-MM-DD") + " " + timeopen + ":00",
        end_time: this.$moment().format("YYYY-MM-DD") + " " + timeclose + ":00",
        mode: this.device,
        device_id: this.device_id,
      };
      if (this.device == "air" && this.temperature.state == true) {
        schedule["temp"] = this.temperature.temp;
      }

      return schedule;
    },
    removeSchedule() {
      this.$API.post("schedule/v2.0/remove", { id: this.id }).then(() => {
        this.$store.dispatch("i_APC/genData");

        this.$store.dispatch("i_APC/getSchedule");
        this.popupActivoAdd = false;
        this.$vs.notify({
          title: "Notification",
          text: "Remove Schdule success",
          color: "success",
          position: "top-center",
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.add {
  margin: 10px 0 0 0;
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  .name {
    width: 100%;
  }
  .time {
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
    align-items: center;
    margin: 15px 0 0 0;
    .temp {
      // width: 100%;
      display: flex;
      flex-direction: column;
      div {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 5px;
      }
    }
  }
  .list-week {
    display: flex;
    justify-content: space-evenly;

    margin: 15px 0 0 0;
    .circle-btn {
      width: 40px;
      height: 40px;
      border-radius: 20px;

      background-color: var(--background-color);
      color: #32c040;
      border: none;
      // border: #32c040 1px solid;
      &:active {
        background-color: #32c040;
        color: white;
      }
    }

    .active {
      background-color: #32c040;
      border: none;
      color: white;
    }
  }
  .btn-submit {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    gap: 10px;
    margin: 15px 0 0 0;
  }
}

.btn-icon {
  cursor: pointer;
}
</style>